import { client } from '@/src/provider/MbaasClient'

export const deleteDefault: any = async (resource: any, params: any) => {
  await client.getTable(resource).del({ id: params.id as string })
  return { data: params }
}
